import { createFeature, createReducer, on } from '@ngrx/store';
import { ApplyJobActions } from './apply-job.actions';
import { ApplyJobState } from './apply-job.models';

export const initialApplyJobState: ApplyJobState = {
  context: null,
  selectedStudents: [],
  formValue: null,
  lastUpdatedAt: null
};

const reducer = createReducer(
  initialApplyJobState,
  on(ApplyJobActions.started, (state, { context, selectedStudents }) => ({
    ...state,
    context,
    selectedStudents,
    lastUpdatedAt: Date.now()
  })),
  on(ApplyJobActions.formUpdated, (state, { formValue, selectedStudents }) => ({
    ...state,
    formValue,
    selectedStudents,
    lastUpdatedAt: Date.now()
  })),
  on(ApplyJobActions.cleared, () => initialApplyJobState)
);

export const applyJobFeature = createFeature({
  name: 'applyJob',
  reducer
});

